'use client';

import { ServiceTabletMobileCard } from './service-insight-tablet-mobile-card';
import { ServiceInsightDesktopCard } from './service-insight-desktop-card';
import { ServiceInsightCardProps } from '../types';
import styles from './service-insight-card.module.scss';

export const ServiceInsightCard = ({
  serviceInsights = []
}: ServiceInsightCardProps) => {
  return (
    <div
      className={`${styles['serviceInsightCard']} d-flex flex-column gap-blg-0 pb-blg-0`}
    >
      <div className="d-flex flex-column gap-2 d-blg-none">
        {serviceInsights.slice(0, 2).map((item) => (
          <ServiceTabletMobileCard key={item.id} serviceInsights={item} />
        ))}
      </div>
      <div className="d-none d-blg-block">
        {serviceInsights.map((item) => (
          <ServiceInsightDesktopCard key={item.id} serviceInsights={item} />
        ))}
      </div>
    </div>
  );
};
